module.exports = __webpack_public_path__ + "CorporateABold.woff2";